import { render, staticRenderFns } from "./AccountArchived.vue?vue&type=template&id=65aeeaf0"
import script from "./AccountArchived.vue?vue&type=script&lang=js"
export * from "./AccountArchived.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports